import React from 'react';
import PropTypes from 'prop-types';

const sizes = {
  small: ['12px', '12px'],
  middle: ['24px', '24px'],
  large: ['32px', '32px'],
};

const BillingIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 53 53"
    width={sizes[props.size][0]}
    height={sizes[props.size][1]}
    style={{
      ...(props.shouldPadding
        ? {
            padding: '4px',
          }
        : {}),
    }}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M15.826 2.5a1 1 0 0 0-1 1v5.55h-1.73a3.073 3.073 0 0 0-3.07 3.07v4.294H9.48a4.275 4.275 0 0 0-4.27 4.27v8.863a4.27 4.27 0 0 0 4.27 4.26h1.471a1 1 0 0 0 0-2h-1.47a2.268 2.268 0 0 1-2.27-2.26v-8.863a2.273 2.273 0 0 1 2.27-2.27H43.52a2.273 2.273 0 0 1 2.27 2.27v8.863a2.268 2.268 0 0 1-2.27 2.26h-1.471a1 1 0 0 0 0 2h1.47a4.27 4.27 0 0 0 4.27-4.26v-8.863a4.275 4.275 0 0 0-4.27-4.27h-.544V12.12a3.073 3.073 0 0 0-3.07-3.068h-1.731V3.5a1 1 0 0 0-1-1H15.826zm1 2h19.348v11.914H16.826V4.5zm3.572 2.66a1 1 0 0 0 0 2h12.204a1 1 0 0 0 0-2H20.398zm-7.302 3.89h1.73v5.364h-2.8V12.12c0-.59.48-1.068 1.07-1.068zm25.078 0h1.73c.59 0 1.07.48 1.07 1.07v4.294h-2.8v-5.363zm-17.776.704a1 1 0 0 0 0 2h12.204a1 1 0 0 0 0-2H20.398zm13.153 8.748c-.552 0-1.053.497-1.053 1.049 0 .552.5 1.053 1.053 1.053.552 0 1.05-.501 1.05-1.053 0-.552-.498-1.049-1.05-1.049zm3.746 0c-.552 0-1.053.497-1.053 1.049 0 .552.5 1.053 1.053 1.053.552 0 1.05-.501 1.05-1.053 0-.552-.498-1.049-1.05-1.049zm3.748 0c-.552 0-1.053.497-1.053 1.049 0 .552.5 1.053 1.053 1.053.552 0 1.05-.501 1.05-1.053 0-.552-.498-1.049-1.05-1.049zm-29.14 6.953a1 1 0 0 0 0 2h2.046v17.49c0 .248.092.487.258.67l2.307 2.555c.379.42 1.105.42 1.484 0l1.564-1.733 1.565 1.733a1 1 0 0 0 1.484 0l1.565-1.733 1.564 1.733c.19.21.458.33.74.33h.002c.283 0 .551-.12.74-.328l1.577-1.736 1.564 1.734c.19.21.46.33.742.33.27-.035.55-.119.74-.328l1.579-1.738 1.576 1.738a.999.999 0 0 0 1.482-.002l2.307-2.555a.999.999 0 0 0 .258-.67v-17.49h2.047a1 1 0 0 0 0-2c.145 0-2.022-.003-29.192 0zm4.046 2H37.05v17.106L35.74 48.01l-1.574-1.737a1.003 1.003 0 0 0-1.482 0l-1.575 1.737-1.566-1.735a.998.998 0 0 0-.74-.33 1.04 1.04 0 0 0-.742.328l-1.575 1.737-1.566-1.735c-.379-.42-1.106-.42-1.484 0l-1.565 1.733-1.564-1.733a1 1 0 0 0-1.485 0l-1.564 1.733-1.307-1.447V29.455zm5.16 2.133a1 1 0 0 0-1 1v.373a3.017 3.017 0 0 0-2.021 2.84 3.032 3.032 0 0 0 3.021 3.037 1.03 1.03 0 0 1 1.037 1.021c0 .572-.465 1.037-1.037 1.037-.468 0-.875-.319-.99-.777a1.003 1.003 0 0 0-1.215-.726.998.998 0 0 0-.724 1.212 3.024 3.024 0 0 0 1.93 2.122v.359a1 1 0 0 0 2 0v-.373a3.032 3.032 0 0 0 2.036-2.854 3.034 3.034 0 0 0-3.037-3.023A1.029 1.029 0 0 1 20.09 35.8c0-.565.457-1.024 1.021-1.024.476 0 .89.316 1.006.77a1 1 0 0 0 1.938-.496 3.024 3.024 0 0 0-1.944-2.106v-.357a1 1 0 0 0-1-1zm6.141.596a1 1 0 0 0 0 2h6.66a1 1 0 0 0 0-2h-6.66zm0 4.654a1 1 0 0 0 0 2h6.66a1 1 0 0 0 0-2h-6.66zm0 4.652a1 1 0 0 0 0 2h6.66a1 1 0 0 0 0-2h-6.66z"
    />
  </svg>
);
BillingIcon.propTypes = {
  size: PropTypes.string,
  shouldPadding: PropTypes.bool,
};
BillingIcon.defaultProps = {
  size: 'middle',
  shouldPadding: false,
};

export default BillingIcon;
